/**
 * 진입 나누기(2026-10-10, /game5 DEV-SPEC 6단계): /game5 는 자기 복사본(src/g5 · src/modes/game5)만 싣는다 —
 * 옛 모드 전부를 정적으로 묶은 main.ts(와 전역 CSS 두 벌)를 받지 않게. 그 밖의 주소는 예전 그대로 main.ts.
 */
const app = document.getElementById('app')!;
const fail = (e: unknown) => { app.textContent = `불러오지 못했어요 — ${(e as Error).message}`; };
if (/^\/game5(\/|$)/.test(location.pathname)) void import('./modes/game5/main5').then((m) => m.start(app)).catch(fail);
else if (/^\/wf5(\/|$)/.test(location.pathname)) void import('./modes/wf5/main').then((m) => m.start(app)).catch(fail);   // /game5 UI/UX 회색 와이어프레임(2026-10-13)
else void import('./main').catch(fail);
